module.exports = __webpack_public_path__ + "img/p-benchmarking.65f7bdd3.png";